import * as React from "react";
import { ControlLabel, FormControl, FormControlProps } from "react-bootstrap";
import { ChangeEvent } from "react";

export interface ISelectOptionItem {
    value: string;
    label: string;
}

interface BasicSelectProps extends FormControlProps {
    label?: string;
    options: ISelectOptionItem[];
    onChangeValue?: (value: string) => void;
}

export const BasicSelect = (props: BasicSelectProps) => {
    const { label, options, onChange, onChangeValue } = props;
    return (
        <>
            {label && <ControlLabel>{label}</ControlLabel>}
            <FormControl
                componentClass={"select"}
                onChange={(e) => {
                    onChange?.(e);
                    const value = e as unknown as ChangeEvent<HTMLInputElement>;
                    onChangeValue?.(value.target.value);
                }}
            >
                {[<option value={"select"}>Select value...</option>].concat(
                    options.map((option, index) => (
                        <option key={index} value={option.value}>
                            {option.label}
                        </option>
                    ))
                )}
            </FormControl>
        </>
    );
};
